module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres9-70a58bc5ae54a4c14efc7844ec6c7fb5.jpg";